import { z } from 'zod'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import {
  columnsSchema,
  labelAndValue,
  order,
  requiredString
} from '@/utils/zod'

export const abscencesAllFilterSchema = z.object({
  semester: requiredString().catch(''),
  students: z.array(labelAndValue()).optional(),
  classes: z.array(labelAndValue()).optional(),
  page: z.number().catch(1),
  pageSize: z.number().catch(DEFAULT_PAGE_SIZE),
  sort: z.string().optional(),
  order: order().optional(),
  ...columnsSchema.shape
})

export type AbsencesAllFiltersKeys = keyof z.infer<
  typeof abscencesAllFilterSchema
>
